// ============================
// LAB ORDER STATUS
// ============================
export const LAB_ORDER_STATUS = Object.freeze({
    ORDERED: 1,
    SAMPLE_COLLECTED: 3,
    // RECEIVED: ,
    // PROCESSING: 4,
    PENDING_RESULTS: 6,
    COMPLETED: 7,
    CANCELLED: 8,
    REJECTED: 9,
});


// ============================
// LAB SPECIMEN STATUS
// ============================
export const LAB_SPECIMEN_STATUS = Object.freeze({
    PENDING_COLLECTION: 1,
    COLLECTED_FROM_PATIENT: 2,
    RECEIVED_AT_LAB: 3,
    REJECTED: 4,
    DISPOSED: 5,
});

// ============================
// RADIOLOGY ORDER STATUS
// ============================

export const RADIOLOGY_ORDER_STATUS = Object.freeze({
    PENDING: 1,
    WAITING_FOR_PREREQUISITE: 2,
    READY_FOR_PROCEDURE: 3,
    IN_PROGRESS: 4,
    PROCEDURE_COMPLETED: 5,
    REPORT_PENDING: 6,
    REPORT_FINALIZED: 7,
    CANCELLED: 8,
});


// ============================
// Service Category
// ============================
export const Service_Category = Object.freeze({
    LAB_TEST: 1,
    PHARMACY: 2,
    CONSULTATION: 3,
    RADIOLOGY: 4,
    PACKAGE: 5,
    WARD: 6,
    NURSING: 7,
    OTHERS: 8,
});
